import { useState } from "react"
import { ImageOff } from "lucide-react"
import { cn } from "@/lib/utils"

export function RemoteImage({ src, alt, className = "" }: { src: string; alt: string; className?: string }) {
  const [failed, setFailed] = useState(false)
  if (failed) return <div className={cn("grid min-h-44 place-items-center bg-slate-100 text-slate-400 dark:bg-white/[.06] dark:text-white/30", className)}><div className="text-center"><ImageOff className="mx-auto size-6" /><span className="mt-2 block text-xs">Image unavailable</span></div></div>
  return <img src={src} alt={alt} loading="lazy" onError={() => setFailed(true)} className={cn("block h-full w-full object-cover", className)} />
}
